import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Button, DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import ChevronRightSolid from '@simplywallst/ui-core/icons/ChevronRightSolid';

interface ExpandableProps {
  open?: boolean;
}
export const CriteriaChecksWrapper = styled(Grid)<ExpandableProps>`
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  padding-top: ${({ theme }) => theme.x2spacePx - 4}px;
  height: auto;
  max-height: ${({ open }) => (open ? '100%' : '132px')};
  width: 100%;
  transition: max-height 0.3s ease-in;
  overflow: hidden;

  ${media.mdUp`
    padding-top: ${({ theme }) => theme.x2spacePx}px;
    max-height: ${({ open }) => (open ? '420px' : '132px')};
  `}
`;

export const CriteriaCheckRow = styled('div')`
  display: flex;
  flex-direction: column;
  svg {
    width: ${({ theme }) => theme.x2spacePx + 4}px;
  }

  ${media.mdUp`
    align-items: center;
    flex-direction: row;
  `}
`;

export const ShowMoreButton = styled(Button)`
  border-radius: 9999px;
  &&& {
    box-shadow: none;
  }
`;

export const ShowMoreIcon = styled(ChevronRightSolid)<ExpandableProps>`
  &&& {
    height: ${({ theme }) => theme.x2spacePx}px;
    opacity: 1;
  }
  ${({ open }) => open && 'transform: rotate(90deg);'}
  transition: transform 0.3s;
`;

export const StatmentChecksWrapper = styled('div')`
  width: 100%;
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) =>
    `${theme.x2spacePx - 4}px ${theme.x2spacePx - 4}px ${
      theme.x2spacePx - 4
    }px ${theme.x2spacePx}px`};
  hr {
    margin: ${({ theme }) => theme.x1spacePx}px 0;
  }

  ${media.mdUp`
    max-width: 320px;
  `}
`;

export const SnowflakeWrapper = styled('div')`
  width: 200px;
  > div {
    max-width: 200px;
  }
`;

export const SnowflakeContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

export const HiddenContent = styled(Grid)<ExpandableProps>`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  ${({ open }) => !open && 'display: none;'}
`;
